/**
 * Badge content component for WebhookStatusIndicator
 */

import { RefreshCwIcon } from 'lucide-react';

export type BadgeContentProps = {
  isRefreshing: boolean;
  IconComponent: React.ComponentType<{ className?: string }>;
  label: string;
  size: 'sm' | 'md';
};

export const BadgeContent = ({
  isRefreshing,
  IconComponent,
  label,
  size,
}: BadgeContentProps): JSX.Element => (
  <div
    className={`flex items-center gap-1 ${size === 'sm' ? 'text-xs' : 'text-sm'}`}
  >
    {isRefreshing ? (
      <RefreshCwIcon
        className={`${size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} animate-spin`}
      />
    ) : (
      <IconComponent className={size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} />
    )}
    <span>{label}</span>
  </div>
);
